var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        visible: _vm.visible,
        id: "admin-non-metrc-facet-value-modal",
        title: _vm.isEdit ? "Edit Facet Value" : "Add Facet Value",
        "hide-footer": "",
        centered: "",
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Facet Dimension" } },
            [
              _c("b-form-select", {
                attrs: {
                  options: _vm.facetDimensions,
                  disabled: _vm.isEdit,
                  state: _vm.fieldValid("facet_key"),
                },
                model: {
                  value: _vm.formData.facet_key,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "facet_key", $$v)
                  },
                  expression: "formData.facet_key",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("facet_key") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.facet_key) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Value Key" } },
            [
              _c("b-form-input", {
                attrs: {
                  type: "text",
                  disabled: _vm.isEdit,
                  state: _vm.fieldValid("value_key"),
                },
                model: {
                  value: _vm.formData.value_key,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "value_key",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.value_key",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("value_key") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.value_key) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Label" } },
            [
              _c("b-form-input", {
                attrs: { type: "text", state: _vm.fieldValid("label") },
                model: {
                  value: _vm.formData.label,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "label",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.label",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("label") } },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.formValidation.label) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Sort Order" } },
            [
              _c("b-form-input", {
                attrs: {
                  type: "number",
                  min: "0",
                  state: _vm.fieldValid("sort_order"),
                },
                model: {
                  value: _vm.formData.sort_order,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sort_order", $$v)
                  },
                  expression: "formData.sort_order",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("sort_order") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formValidation.sort_order) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: {
                type: "submit",
                variant: "success",
                disabled: _vm.formState.processing,
              },
            },
            [
              _vm._v("\n      Submit\n      "),
              _vm.formState.processing
                ? _c("b-spinner", { staticClass: "ml-1", attrs: { small: "" } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              attrs: { type: "button", variant: "secondary" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.close.apply(null, arguments)
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }